/** *
 * 用户管理
 */
import Main from '@components/main/main'

const userCenter = {
  path: '/userCenter',
  component: Main,
  redirect: '/userCenter/accountManage',
  children: [{
    name: 'accountManage',
    path: '/userCenter/accountManage',
    component: () => import('@pages/userCenter/pages/accountManage'),
    meta: {
      auth: true,
      title: '角色管理'
    }
  },
  // {
  //   name: 'roleDetail',
  //   path: '/userCenter/roleDetail',
  //   component: () => import('@pages/userCenter/pages/roleDetail'),
  //   meta: {
  //     auth: true,
  //     title: '编辑角色',
  //   }
  // },
  {
    name: 'roleAuthEdit',
    path: '/userCenter/roleAuthEdit',
    component: () => import('@pages/userCenter/pages/roleAuthEdit'),
    meta: {
      auth: true,
      title: '编辑角色'
    }
  },
  {
    name: 'memberDetail',
    path: '/userCenter/memberDetail',
    component: () => import('@pages/userCenter/pages/memberDetail'),
    meta: {
      auth: true,
      title: '修改成员信息'
    }
  }]
}

export default userCenter



// WEBPACK FOOTER //
// ./src/pages/userCenter/index.js